// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"287":"a19defce","1484":"e74c06ad","1830":"ad35e067","2134":"77b59ff4","3290":"58a36781","6948":"686d305e"}[chunkId] + ".chunk.css";
};